/*
 * INO — Kendi Setini Yap / set oluşturucu v2 — kompakt akış (Agentcy 28.10.2026)
 * sections/ino-kendi-setini-yap.liquid içindeki <mys-builder> elemanını çalıştırır.
 *
 * Akış: ürünler tek listede (açılır pencere yok) → renk yuvarlağına dokun → "Ekle".
 * Üstte "setin" kutucukları dolar, indirim basamağı ve "1 ürün daha → %45" yönlendirmesi görünür.
 * Mobilde alttaki yapışkan çubuk toplamı ve "Sepete ekle"yi her an gösterir.
 *
 * - Fiyat/indirim: /search/suggest?q=MYSQ~varyant*adet~...~H~varyant...&section_id=ino-mys-quote
 *   (sunucuda snippets/ino-mys-engine). Tarayıcı yalnızca varyant ID'si ve adet gönderir; fiyatlar,
 *   maliyetler, set kuralları sunucuda okunur. Buraya yalnızca oran, tutarlar ve öneri döner.
 * - Sepete ekleme: ürünler tekli satır olarak eklenir; her satırda
 *     Set: "Kendi Setin" (görünür), _mys: set kimliği
 *   İndirimi "INO Kendi Setini Yap" uygulamasının fonksiyonu sepetin gerçek içeriğinden kendisi
 *   hesaplar; tarayıcıdan gelen hiçbir yüzdeye güvenmez.
 * - Iconic Bag hediyesi sepet çekmecesindeki otomatik hediye akışıyla (ino-free-gift.js) aynı
 *   eşikle gösterilir; set ürünleri set indirimi SONRASI ödenen tutarla sayılır.
 * - Set hediyesi (canvas çanta, bag.setGift — ino_mys.config → setGift): en az minItems ürünlük
 *   sete 1 adet hediye; sepette zaten varsa tekrar eklenmez. Sepette _mys_set_gift ile işaretlenir,
 *   ino-free-gift.js set bozulunca çıkarır, indirim fonksiyonu 0 TL yapar. Iconic Bag ile birlikte
 *   verilebilir; Iconic eşiğine sayılmaz.
 * - Exclusive çanta (ino_mys.config → exclusiveGift, bilgisi teklifle gelir: data-mys-ex): seçim
 *   Ultimate / Full Glam ile birebir aynıysa canvas yerine hediye (_mys_ex_gift).
 */
(function () {
  if (customElements.get('mys-builder')) return;

  var STORE_KEY = 'ino-mys-v1';
  var STORE_TTL = 7 * 24 * 3600 * 1000;

  function money(cents) {
    var out;
    try {
      out = FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    } catch (e) {
      out = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }
    return String(out).replace(/[.,]00(?=[^0-9]*$)/, '');
  }

  // Türkçe yönelme eki: %40'a, %45'e, %50'ye, %60'a ...
  function dat(n) {
    var u = n % 10;
    var t = Math.floor(n / 10) % 10;
    var byUnit = { 1: "'e", 2: "'ye", 3: "'e", 4: "'e", 5: "'e", 6: "'ya", 7: "'ye", 8: "'e", 9: "'a" };
    var byTen = { 0: "'a", 1: "'a", 2: "'ye", 3: "'a", 4: "'a", 5: "'ye", 6: "'a", 7: "'e", 8: "'e", 9: "'a" };
    if (n === 0) return "'a";
    return u ? byUnit[u] : byTen[t];
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function fetchJSONCfg() {
    try { return FoxTheme.utils.fetchConfig('json'); } catch (e) {
      return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  var ICON_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';
  var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.3C7 7 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.3C17 7 14.5 7 12 7z"/></svg>';

  class MysBuilder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      if (this.dataset.enabled === 'false') { this.hidden = true; return; }

      var dataEl = this.querySelector('[data-mys-data]');
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[mys] data', e); return; }

      this.maxItems = parseInt(this.dataset.maxItems, 10) || 12;
      this.maxPerVariant = parseInt(this.dataset.maxPerVariant, 10) || 3;
      this.minItems = parseInt(this.dataset.minItems, 10) || 2;
      this.maxPct = parseInt(this.dataset.maxPct, 10) || 50;

      this.options = {};
      this.data.groups = this.data.groups.filter(function (g) { return g.options.length > 0; });
      this.data.groups.forEach(function (g) {
        g.options.forEach(function (o) { this.options[o.variantId] = { group: g, opt: o }; }, this);
        var firstAvail = g.options.findIndex(function (o) { return o.available; });
        g._sel = firstAvail < 0 ? 0 : firstAvail;
      }, this);

      var gift = window.inoFreeGift || null;
      this.data.bags.forEach(function (b) {
        if (gift && gift.active && Number(gift.variantId) === b.variantId) {
          b.mode = 'auto';
          b.giftThreshold = Number(gift.threshold) || b.giftThreshold;
        } else if (b.setGift) {
          b.mode = 'set';
        } else {
          b.mode = b.giftThreshold > 0 ? 'gift' : 'paid';
        }
      });

      this.units = [];
      this.bagSel = {};
      this.quoteData = null;
      this.quoteSeq = 0;
      this.cartEligible = 0;
      this.cartHasGift = false;
      this.cartHasSetGift = false;
      this.cartHasEx = false;
      this.exInfo = null;

      this.$ = function (sel) { return this.querySelector(sel); }.bind(this);
      this.restore();
      this.bind();
      this.renderAll();
      this.loadCart();
      this.requestQuote();
      this.observeBar();
    }

    /* ---------- durum ---------- */
    restore() {
      try {
        var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
        if (!raw || Date.now() - (raw.t || 0) > STORE_TTL) return;
        (raw.u || []).forEach(function (id) {
          var hit = this.options[id];
          if (hit && hit.opt.available && this.units.length < this.maxItems) this.units.push(id);
        }, this);
        (raw.b || []).forEach(function (id) {
          if (this.data.bags.some(function (b) { return b.variantId === id && b.mode !== 'auto' && b.mode !== 'set'; })) this.bagSel[id] = true;
        }, this);
        // Son seçili renkler sette olanlara dönsün
        this.units.forEach(function (id) {
          var hit = this.options[id];
          hit.group._sel = hit.group.options.indexOf(hit.opt);
        }, this);
      } catch (e) { /* tarayıcı depolaması kapalı olabilir */ }
    }
    persist() {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({ u: this.units, b: Object.keys(this.bagSel).map(Number), t: Date.now() }));
      } catch (e) { /* yok say */ }
    }
    countOf(id) {
      id = String(id);
      return this.units.filter(function (u) { return String(u) === id; }).length;
    }
    groupCount(g) {
      return g.options.reduce(function (s, op) { return s + this.countOf(op.variantId); }.bind(this), 0);
    }
    agg() {
      var order = [], map = {};
      this.units.forEach(function (id) {
        if (!map[id]) { map[id] = 0; order.push(id); }
        map[id] += 1;
      });
      return order.map(function (id) { return { id: id, qty: map[id] }; });
    }

    add(id) {
      id = String(id);
      var hit = this.options[id];
      if (!hit || !hit.opt.available) return false;
      if (this.units.length >= this.maxItems) { this.toast('Setine en fazla ' + this.maxItems + ' ürün ekleyebilirsin.'); return false; }
      var lim = this.maxFor(id);
      if (this.groupCount(hit.group) >= lim) { this.toast('Bu üründen en fazla ' + lim + ' adet ekleyebilirsin.'); return false; }
      this.units.push(id);
      this._newId = id;
      this.changed();
      return true;
    }
    // Ürün başına sınır (tüm renkler toplamı) — indirim fonksiyonu da aynı sınırı uygular
    maxFor(id) {
      var hit = this.options[id];
      return (hit && hit.group.maxQty) || 4;
    }
    removeAt(index) {
      this.units.splice(index, 1);
      this.changed();
    }
    removeOne(id) {
      var i = this.units.map(String).lastIndexOf(String(id));
      if (i > -1) this.removeAt(i);
    }
    changed() {
      this.persist();
      this.renderAll();
      this.requestQuote();
    }

    /* ---------- tutarlar (yerel) ---------- */
    totals() {
      var list = 0, price = 0, bags = 0;
      this.units.forEach(function (id) { var o = this.options[id].opt; list += o.list; price += o.price; }, this);
      // Iconic Bag eşiği müşterinin ÖDEYECEĞİ tutara bakar: set indirimi düşülmüş fiyat (teklif gelene
      // kadar son bilinen oranla tahmin edilir).
      var q = this.fresh();
      // Tahmin: oran liste fiyatına uygulanır, ürün zaten daha ucuzsa o fiyat kalır (fonksiyonla aynı).
      var estPct = this.units.length >= this.minItems ? (this._barPct || 0) : 0;
      var setPay = q ? q.pay : Math.round(this.units.reduce(function (s, id) {
        var o = this.options[id].opt;
        return s + Math.min(o.price, o.list * (100 - estPct) / 100);
      }.bind(this), 0));
      // Yalnızca bu sayfadaki seçim sayılır; sepette önceden duran ürünler/hediyeler bu hesaba karışmaz.
      var elig = setPay;
      this.data.bags.forEach(function (b) {
        if (b.mode === 'auto' || !this.bagSel[b.variantId]) return;
        elig += b.price;
      }, this);
      var gifts = {};
      var exOn = this.exOn();
      this.data.bags.forEach(function (b) {
        if (b.mode === 'paid') return;
        // Exclusive çanta: seçim Ultimate / Full Glam ile birebir aynıysa canvas yerine
        if (b.mode === 'ex') { gifts[b.variantId] = exOn; return; }
        // Set hediyesi: en az minItems ürünlük sete (Exclusive'e girmeyen seçimlerde)
        if (b.mode === 'set') { gifts[b.variantId] = !exOn && this.units.length >= this.minItems; return; }
        if (b.mode === 'gift' && !this.bagSel[b.variantId]) return;
        gifts[b.variantId] = this.units.length > 0 && elig >= b.giftThreshold;
      }, this);
      this.data.bags.forEach(function (b) {
        if (b.mode === 'auto' || !this.bagSel[b.variantId]) return;
        if (!gifts[b.variantId]) bags += b.price;
      }, this);
      return { list: list, price: price, bags: bags, elig: elig, gifts: gifts };
    }
    /* ---------- sunucu teklifi ---------- */
    requestQuote() {
      clearTimeout(this._qt);
      this._qt = setTimeout(this.quote.bind(this), 200);
    }
    quote() {
      var seq = ++this.quoteSeq;
      if (!this.units.length) {
        this.quoteData = null;
        this.renderPrices();
        return Promise.resolve(null);
      }
      // Yalnızca varyant ID'si ve adet; öneri için her ürünün seçili rengi
      var lines = this.agg().map(function (a) { return a.id + '*' + a.qty; });
      var hints = this.data.groups.map(function (g) {
        var o = g.options[g._sel] && g.options[g._sel].available ? g.options[g._sel] : g.options.find(function (x) { return x.available; });
        return o ? o.variantId : null;
      }).filter(Boolean);
      var url = rootUrl() + 'search/suggest?q=' + encodeURIComponent('MYSQ~' + lines.join('~') + '~H~' + hints.join('~')) + '&resources[type]=page&resources[limit]=1&section_id=ino-mys-quote';
      this.classList.add('is-quoting');
      var self = this;
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-mys-json[^>]*>([\s\S]*?)<\/script>/);
          if (!m) throw new Error('quote-parse');
          self.setExInfo(html);
          return JSON.parse(m[1]);
        })
        .then(function (q) {
          if (seq !== self.quoteSeq) return q;
          self.quoteData = q && q.ok ? q : null;
          self.renderPrices();
          return q;
        })
        .catch(function (err) {
          console.warn('[mys] quote failed', err);
          if (seq === self.quoteSeq) { self.quoteData = null; self.renderPrices(); }
          return null;
        })
        .finally(function () { if (seq === self.quoteSeq) self.classList.remove('is-quoting'); });
    }
    pctFor(id) {
      var q = this.quoteData;
      if (!q) return 0;
      var hit = q.lines.find(function (l) { return String(l.ref) === String(id); });
      return hit ? hit.pct : 0;
    }
    fresh() {
      var q = this.quoteData;
      return q && q.units === this.units.length ? q : null;
    }
    // Seçim Exclusive çantalı bir hazır setle (sunucu teklifindeki "exact") birebir aynı mı?
    exOn() {
      var q = this.fresh();
      var ex = this.exInfo;
      return !!(q && q.exact && ex && ex.available && (ex.sets || []).indexOf(q.exact) > -1 && this.units.length >= this.minItems);
    }
    setExInfo(html) {
      var m = html.match(/<script[^>]*data-mys-ex[^>]*>([\s\S]*?)<\/script>/);
      if (!m) return;
      var ex = null;
      try { ex = JSON.parse(m[1]); } catch (e) { return; }
      if (!ex || !ex.variantId) return;
      this.exInfo = ex;
      if (!this.data.bags.some(function (b) { return b.mode === 'ex'; })) {
        this.data.bags.push({ variantId: Number(ex.variantId), title: ex.title, image: ex.image, price: Number(ex.price) || 0, mode: 'ex', giftThreshold: 0 });
      }
    }

    loadCart() {
      var self = this;
      var gift = window.inoFreeGift || {};
      var calc = function (cart) {
        var items = (cart && cart.items) || [];
        var isGift = function (it) {
          return (it.properties && (it.properties._ino_free_gift === 'true' || it.properties._mys_gift === 'true')) ||
            (gift.variantId && it.variant_id === Number(gift.variantId) && !(it.properties && it.properties._mys_bag));
        };
        var isSetGift = function (it) { return !!(it.properties && (it.properties._mys_set_gift === 'true' || it.properties._mys_ex_gift === 'true')); };
        self.cartHasGift = items.some(isGift);
        self.cartHasSetGift = items.some(function (it) { return !!(it.properties && it.properties._mys_set_gift === 'true'); });
        self.cartHasEx = items.some(function (it) { return !!(it.properties && it.properties._mys_ex_gift === 'true'); });
        // Kendi Setin satırları indirimli (ödenen) fiyatla, diğerleri ino-free-gift.js ile aynı tabanla sayılır
        self.cartEligible = items.reduce(function (s, it) {
          if (isGift(it) || isSetGift(it)) return s;
          var paid = it.properties && it.properties._mys && it.final_line_price != null ? it.final_line_price : it.original_line_price;
          return s + paid;
        }, 0);
        self.renderPrices();
        self.renderBags();
        self.requestQuote();
      };
      fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(calc).catch(function () {});
      document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) calc(e.detail.cart); });
    }

    /* ---------- olaylar ---------- */
    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-close-modal')) { self.closeModal(); return; }
        var t = e.target.closest('button');
        if (!t || !self.contains(t) || t.disabled) return;
        if (t.hasAttribute('data-info')) { self.openModal(t.dataset.info); return; }
        if (t.hasAttribute('data-close-modal')) { self.closeModal(); return; }
        if (t.hasAttribute('data-remove-id')) { self.removeOne(t.dataset.removeId); return; }
        if (t.hasAttribute('data-remove')) { self.removeAt(parseInt(t.dataset.remove, 10)); return; }
        if (t.hasAttribute('data-clear')) { self.units = []; self.bagSel = {}; self.changed(); return; }
        if (t.hasAttribute('data-goto-list')) {
          var first = self.$('[data-list] .mys__row');
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (t.hasAttribute('data-go-summary')) {
          self.$('[data-summary]').scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (t.hasAttribute('data-color')) {
          var g = self.groupById(t.dataset.group);
          g._sel = parseInt(t.dataset.color, 10);
          self.renderRow(g);
          if (self._modalGroup === g.id) self.renderModal();
          return;
        }
        if (t.hasAttribute('data-row-add') || t.hasAttribute('data-row-plus')) {
          var g2 = self.groupById(t.dataset.group);
          var o2 = g2.options[g2._sel];
          if (self.add(o2.variantId)) {
            self.toast(g2.title + (g2.options.length > 1 ? ' · ' + o2.label : '') + ' setine eklendi');
            self.focusRowAction(g2, '[data-row-plus]');
          }
          return;
        }
        if (t.hasAttribute('data-row-minus')) {
          var g3 = self.groupById(t.dataset.group);
          self.removeOne(g3.options[g3._sel].variantId);
          self.focusRowAction(g3, '[data-row-minus], [data-row-add]');
          return;
        }
        if (t.hasAttribute('data-bag')) {
          var id = parseInt(t.dataset.bag, 10);
          var bag = self.data.bags.find(function (b) { return b.variantId === id; });
          if (!bag || bag.mode === 'auto' || bag.mode === 'set') return;
          if (self.bagSel[id]) delete self.bagSel[id]; else self.bagSel[id] = true;
          self.changed();
          return;
        }
        if (t.hasAttribute('data-atc') || t.hasAttribute('data-atc-bar')) { self.addToCart(); }
      });
    }
    groupById(id) { return this.data.groups.find(function (g) { return g.id === id; }); }

    /* ---------- ürün detayı penceresi ---------- */
    openModal(gid) {
      this._modalGroup = gid;
      this._returnFocus = document.activeElement;
      this.$('[data-modal]').hidden = false;
      document.documentElement.classList.add('mys-lock');
      this.renderModal();
      var panel = this.$('.mys__modal-panel');
      setTimeout(function () { panel.focus(); }, 30);
      if (!this._escBound) {
        this._escBound = true;
        var self = this;
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self._modalGroup) self.closeModal(); });
      }
    }
    closeModal() {
      this._modalGroup = null;
      this.$('[data-modal]').hidden = true;
      document.documentElement.classList.remove('mys-lock');
      if (this._returnFocus && this._returnFocus.focus) this._returnFocus.focus({ preventScroll: true });
    }
    renderModal() {
      var g = this._modalGroup && this.groupById(this._modalGroup);
      if (!g) return;
      var o = g.options[g._sel];
      var benefits = (g.benefits || []).map(function (b) { return String(b).trim(); }).filter(Boolean);
      var img = o.image || o.thumb;
      var html =
        '<div class="mys__m-top">' +
          '<div class="mys__m-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(g.title + ' ' + o.label) + '" width="480" height="480">' : '') + '</div>' +
          '<div class="mys__m-head"><h3 class="mys__m-title">' + esc(g.title) + '</h3>' +
            (g.subtitle ? '<p class="mys__row-sub">' + esc(g.subtitle) + '</p>' : '') +
            '<p class="mys__row-price">' + (o.list > o.price ? '<s>' + money(o.list) + '</s> ' : '') + '<b>' + money(o.price) + '</b></p>' +
            (g.promo ? '<span class="mys__promo">' + esc(g.promo) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<div class="mys__m-act">' + this.colorsHtml(g) + '<div class="mys__m-btn">' + this.actionHtml(g) + '</div></div>' +
        (benefits.length ? '<h4 class="mys__m-h">Ne işe yarar?</h4><ul class="mys__m-list">' + benefits.map(function (b) { return '<li>' + ICON_CHECK + '<span>' + esc(b) + '</span></li>'; }).join('') + '</ul>' : '') +
        (g.ingredients ? '<h4 class="mys__m-h">Öne çıkan içerikler</h4><p class="mys__m-p">' + esc(g.ingredients) + '</p>' : '') +
        (g.usage ? '<h4 class="mys__m-h">Nasıl kullanılır?</h4><p class="mys__m-p">' + esc(g.usage) + '</p>' : '') +
        (o.url || g.url ? '<a class="mys__m-link" href="' + esc(o.url || g.url) + '" target="_blank" rel="noopener">Ürün sayfasının tamamını gör</a>' : '');
      this.$('[data-modal-body]').innerHTML = html;
    }
    focusRowAction(g, sel) {
      var row = this.rowEl(g);
      var btn = row && row.querySelector(sel);
      if (btn && !btn.disabled) btn.focus({ preventScroll: true });
    }
    rowEl(g) {
      return this.querySelector('[data-row="' + (window.CSS && CSS.escape ? CSS.escape(g.id) : g.id) + '"]');
    }

    toast(msg) {
      var el = document.querySelector('.mys__toast');
      if (!el) { el = document.createElement('div'); el.className = 'mys__toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
      el.textContent = msg;
      el.classList.add('is-on');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(function () { el.classList.remove('is-on'); }, 1600);
    }

    /* ---------- çizim ---------- */
    renderAll() {
      this.renderList();
      this.renderBags();
      this.renderPrices();
      if (this._modalGroup) this.renderModal();
    }

    renderList() {
      var list = this.$('[data-list]');
      if (!list.children.length) {
        list.innerHTML = this.data.groups.map(function (g) {
          return '<li class="mys__row" data-row="' + esc(g.id) + '"></li>';
        }).join('');
      }
      this.data.groups.forEach(this.renderRow, this);
    }

    colorsHtml(g) {
      if (g.options.length < 2) return '';
      var o = g.options[g._sel];
      return '<div class="mys__colors" role="group" aria-label="' + esc(g.title) + ' rengi">' + g.options.map(function (op, i) {
        var c = this.countOf(op.variantId);
        var bg = op.hex ? 'background:' + esc(op.hex) : (op.thumb ? 'background-image:url(' + esc(op.thumb) + ')' : '');
        return '<button type="button" class="mys__color' + (c ? ' has-qty' : '') + '" data-group="' + esc(g.id) + '" data-color="' + i + '" aria-pressed="' + (i === g._sel) + '" aria-label="' + esc(op.label) + (c ? ', setinde ' + c : '') + (op.available ? '' : ' (tükendi)') + '"' + (op.available ? '' : ' disabled') + '>' +
          '<span style="' + bg + '"></span>' + (c ? '<i>' + c + '</i>' : '') + '</button>';
      }, this).join('') + '<span class="mys__cname">' + esc(o.label) + '</span></div>';
    }

    actionHtml(g) {
      var o = g.options[g._sel];
      var qty = this.countOf(o.variantId);
      var full = this.units.length >= this.maxItems;
      var multi = g.options.length > 1;
      if (!o.available) return '<span class="mys__soldout">Tükendi</span>';
      if (qty > 0) {
        return '<div class="mys__stepper" role="group" aria-label="' + esc(g.title + (multi ? ' ' + o.label : '')) + ' adedi">' +
          '<button type="button" data-row-minus data-group="' + esc(g.id) + '" aria-label="Bir adet çıkar">−</button>' +
          '<output aria-live="polite">' + qty + '</output>' +
          '<button type="button" data-row-plus data-group="' + esc(g.id) + '" aria-label="Bir adet daha ekle"' + (this.groupCount(g) >= this.maxFor(o.variantId) || full ? ' disabled' : '') + '>+</button></div>';
      }
      return '<button type="button" class="mys__add" data-row-add data-group="' + esc(g.id) + '"' + (full ? ' disabled' : '') +
        ' aria-label="' + esc(g.title + (multi ? ' ' + o.label : '')) + ' setine ekle"><span aria-hidden="true">+</span> Ekle</button>';
    }

    renderRow(g) {
      var li = this.rowEl(g);
      if (!li) return;
      var o = g.options[g._sel];
      var inSet = this.groupCount(g);
      var price = (o.list > o.price ? '<s>' + money(o.list) + '</s> ' : '') + '<b>' + money(o.price) + '</b>';
      var img = o.thumb || o.image;
      var sub = g.highlights || g.subtitle;
      var hasInfo = (g.benefits && g.benefits.some(function (b) { return String(b).trim(); })) || g.ingredients || g.usage;
      li.classList.toggle('is-in', inSet > 0);
      li.innerHTML =
        '<div class="mys__row-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="200" height="200">' : '') +
        (inSet ? '<span class="mys__row-badge" aria-hidden="true">' + inSet + '</span>' : '') + '</div>' +
        '<div class="mys__row-info"><h3 class="mys__row-title">' + esc(g.title) + '</h3>' +
        (sub ? '<p class="mys__row-sub">' + esc(sub) + '</p>' : '') +
        '<p class="mys__row-price">' + price +
        (hasInfo ? ' <button type="button" class="mys__info" data-info="' + esc(g.id) + '" aria-label="' + esc(g.title) + ' detayları">Detaylar</button>' : '') + '</p>' +
        (g.promo ? '<span class="mys__promo">' + esc(g.promo) + '</span>' : '') + '</div>' +
        '<div class="mys__row-act">' + this.actionHtml(g) + '</div>' + this.colorsHtml(g);
    }

    renderBags() {
      var list = this.$('[data-bags]');
      if (!list) return;
      var t = this.totals();
      var n = this.units.length;
      list.innerHTML = this.data.bags.map(function (b) {
        var isGift = !!t.gifts[b.variantId];
        var sel = !!this.bagSel[b.variantId];
        var sub = '', act = '', progress = '';
        // Bu sayfa yalnızca o anki seçime bakar; sepetteki önceki setler/hediyeler burada gösterilmez.
        if (b.mode === 'ex' && !isGift) return '';
        // Exclusive çanta bu seçimde canvas'ın yerine geçer: canvas satırı gizlenir
        if (b.mode === 'set' && this.exOn()) return '';
        if (b.mode === 'ex') {
          sub = '<b class="mys__ok">Bu sete özel, hediye olarak sepetine eklenecek</b>';
        } else if (b.mode === 'set') {
          if (isGift) sub = '<b class="mys__ok">Hediye olarak sepetine eklenecek</b>';
          else sub = this.minItems + ' ürünlük her sete hediye';
        } else if (b.mode === 'auto' || b.mode === 'gift') {
          var left = Math.max(0, b.giftThreshold - t.elig);
          var pct = Math.min(100, Math.round((t.elig / b.giftThreshold) * 100));
          if (isGift) {
            sub = '<b class="mys__ok">Hediye olarak sepetine eklenecek</b>';
          } else if (b.mode === 'auto') {
            sub = n ? 'Hediyene <b>' + money(left) + '</b> kaldı' : money(b.giftThreshold) + ' ve üzeri setlerde hediye';
            progress = '<span class="mys__progress" aria-hidden="true"><span style="width:' + (n ? pct : 0) + '%"></span></span>';
          } else {
            sub = money(b.giftThreshold) + ' ve üzeri setlerde hediye';
          }
        } else if (b.note) {
          sub = esc(b.note);
        }
        var priceTxt = (b.mode === 'auto' || b.mode === 'set' || b.mode === 'ex' || isGift) ? '<s>' + money(b.price) + '</s> <b class="mys__ok">Hediye</b>' : '<b>' + money(b.price) + '</b>';
        if (b.mode === 'ex') {
          act = '<span class="mys__tag mys__tag--ok">' + ICON_CHECK + ' Hediye</span>';
        } else if (b.mode === 'set') {
          act = isGift ? '<span class="mys__tag mys__tag--ok">' + ICON_CHECK + ' Hediye</span>'
            : '<span class="mys__tag">' + ICON_GIFT + ' Hediye</span>';
        } else if (b.mode === 'auto') {
          act = isGift ? '<span class="mys__tag mys__tag--ok">' + ICON_CHECK + ' Hediye</span>' : '<span class="mys__tag">' + ICON_GIFT + ' Hediye</span>';
        } else if (isGift) {
          act = '<span class="mys__tag mys__tag--ok">' + ICON_CHECK + ' Hediye</span>';
        } else {
          act = '<button type="button" class="mys__add' + (sel ? ' is-on' : '') + '" data-bag="' + b.variantId + '" aria-pressed="' + sel + '">' + (sel ? ICON_CHECK + ' Eklendi' : '<span aria-hidden="true">+</span> Ekle') + '</button>';
        }
        return '<li class="mys__row mys__row--bag' + (isGift ? ' is-gift' : '') + '">' +
          '<div class="mys__row-img">' + (b.image ? '<img src="' + esc(b.image) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</div>' +
          '<div class="mys__row-info"><h3 class="mys__row-title">' + esc(b.title) + '</h3>' +
          '<p class="mys__row-sub">' + sub + '</p>' + progress +
          '<p class="mys__row-price">' + priceTxt + '</p></div>' +
          '<div class="mys__row-act">' + act + '</div></li>';
      }, this).join('');
    }

    // Setin kutucukları + indirim basamağı + yönlendirme (mobilde üstte, masaüstünde sağ sütunda)
    statusHtml(t, pct) {
      var n = this.units.length;
      var q = this.fresh();
      var hintHit = q && q.hint ? this.options[String(q.hint.vid)] : null;
      var target = n < this.minItems ? this.minItems : (hintHit ? n + 1 : n);

      // Başlık satırı
      var head;
      if (n === 0) head = '<b>Setini oluştur</b>';
      else if (pct > 0) head = '<b>Set indirimin <em>%' + pct + '</em></b>';
      else head = '<b>' + n + ' ürün seçtin</b>';
      if (n) head += '<button type="button" class="mys__clear" data-clear>Temizle</button>';

      // Kutucuklar: dolu olanlar + bir sonraki basamağa kadar boşlar
      var empties = Math.max(0, Math.min(target, this.maxItems) - n);
      if (n === 0) empties = this.minItems;
      // Aynı ürün (aynı renk) tek karede "×N" ile; farklı renkler ayrı karede.
      var tiles = this.agg().map(function (a) {
        var hit = this.options[a.id];
        var o = hit.opt;
        var name = hit.group.title + (hit.group.options.length > 1 ? ' ' + o.label : '');
        var isNew = String(a.id) === String(this._newId);
        return '<li class="mys__tile' + (isNew ? (a.qty > 1 ? ' is-bump' : ' is-new') : '') + '">' +
          (o.thumb ? '<img src="' + esc(o.thumb) + '" alt="" width="96" height="96">' : '') +
          (o.hex && hit.group.options.length > 1 ? '<span class="mys__tile-dot" style="background:' + esc(o.hex) + '"></span>' : '') +
          (a.qty > 1 ? '<span class="mys__tile-qty" aria-hidden="true">×' + a.qty + '</span>' : '') +
          '<button type="button" class="mys__tile-x" data-remove-id="' + esc(a.id) + '" aria-label="' + esc(name) + (a.qty > 1 ? ' (' + a.qty + ' adet): 1 adet çıkar' : ' setten çıkar') + '">' + (a.qty > 1 ? ICON_MINUS : ICON_X) + '</button></li>';
      }, this).join('');
      for (var k = 0; k < empties; k++) {
        tiles += '<li class="mys__tile mys__tile--empty"><button type="button" data-goto-list aria-label="Ürün ekle"><span aria-hidden="true">+</span></button></li>';
      }
      // Hediye çantalar (set hediyesi canvas çanta + eşik hediyesi Iconic Bag) setin sağında yan
      // yana; kilitliyken soluk + dolan şerit, kazanılınca (ya da sepette zaten varsa) aktif.
      var slots = [], onNames = [], cartNames = [], locked = [], anyActive = false;
      this._giftOn = this._giftOn || {};
      var exOn = this.exOn();
      var giftBags = this.data.bags.filter(function (b) { return b.mode !== 'paid' && !(b.mode === 'set' && exOn); })
        .sort(function (a, b) { return (a.mode === 'set' || a.mode === 'ex' ? 0 : 1) - (b.mode === 'set' || b.mode === 'ex' ? 0 : 1); });
      giftBags.forEach(function (b) {
        var on = !!t.gifts[b.variantId];
        var inCart = false; // sepetteki önceki hediyeler bu seçime karışmaz
        if ((b.mode === 'gift' || b.mode === 'ex') && !on && !inCart) return;
        var active = on || inCart;
        anyActive = anyActive || active;
        var prog = b.mode === 'set'
          ? Math.round(Math.min(n, this.minItems) / this.minItems * 100)
          : Math.max(0, Math.min(100, Math.round(t.elig / b.giftThreshold * 100)));
        var wasOn = this._giftOn[b.variantId];
        this._giftOn[b.variantId] = active;
        var cond = b.mode === 'set' ? this.minItems + ' ürünlük setlere ' : money(b.giftThreshold) + ' ve üzeri setlerde ';
        var label = inCart ? b.title + ' hediyen sepetinde' : on ? b.title + ' hediye' : cond + b.title + ' hediye';
        slots.push('<div class="mys__tile mys__tile--gift' + (active ? ' is-on' : ' is-locked') + (active && wasOn === false ? ' is-unlock' : '') + '" title="' + esc(label) + '">' +
          (b.image ? '<img src="' + esc(b.image) + '" alt="' + esc(label) + '" width="96" height="96">' : '') +
          (active ? '' : '<span class="mys__tile-prog" aria-hidden="true"><span style="width:' + prog + '%"></span></span>') +
          '<span class="mys__tile-gift">' + (active ? ICON_CHECK : ICON_GIFT) + '</span></div>');
        if (inCart) cartNames.push(b.title);
        else if (on) onNames.push(b.title);
        else if (b.mode === 'set') locked.push(this.minItems + ' ürünlük her sete <b>' + esc(b.title) + '</b> hediye.');
        else if (n) locked.push('<b>' + esc(b.title) + '</b> hediyene <b>' + money(Math.max(0, b.giftThreshold - t.elig)) + '</b> kaldı.');
        else locked.push(money(b.giftThreshold) + ' ve üzeri setlerde <b>' + esc(b.title) + '</b> hediye.');
      }, this);
      var giftSlot = slots.length ? '<div class="mys__gift-slot' + (anyActive ? ' is-on' : '') + '"><div class="mys__gift-tiles">' + slots.join('') + '</div>' +
        '<span class="mys__gift-cap">Hediye</span></div>' : '';
      var bold = function (arr) { return arr.map(function (x) { return '<b>' + esc(x) + '</b>'; }).join(' ve '); };
      var giftLine = '';
      if (onNames.length) giftLine += '<p class="mys__giftline is-on">' + ICON_GIFT + ' ' + bold(onNames) + ' hediye olarak sepetine eklenecek!</p>';
      if (cartNames.length) giftLine += '<p class="mys__giftline is-on">' + ICON_GIFT + ' ' + bold(cartNames) + (cartNames.length > 1 ? ' hediyelerin' : ' hediyen') + ' sepetinde.</p>';
      locked.forEach(function (l) { giftLine += '<p class="mys__giftline">' + ICON_GIFT + ' ' + l + '</p>'; });

      // Yönlendirme: sunucu hesaplar (set kuralları ve oranlar tarayıcıya gelmez)
      var nudge;
      if (n === 0) nudge = '<b>' + this.minItems + ' ürün</b> seç, set indirimin başlasın.';
      else if (n < this.minItems) nudge = '<b>' + (this.minItems - n) + ' ürün daha</b> ekle, set indirimin başlasın.';
      else if (q && q.valid === false) nudge = 'Bir üründen en fazla 4 adet ekleyebilirsin.';
      else if (q && q.set) nudge = ICON_CHECK + ' <b>' + esc(q.set) + '</b> ile aynı seçim — set fiyatı uygulandı.';
      else if (q && q.hint && hintHit) nudge = '<b>1 ' + esc(hintHit.group.title) + '</b> daha ekle, ' + (q.hint.set ? '<b>' + esc(q.hint.set) + '</b> ile ' : 'indirimin ') + '%' + q.hint.pct + (q.hint.set ? ' indirim al.' : dat(q.hint.pct) + ' çıksın.');
      else if (q) nudge = 'Bu set için en yüksek indirime ulaştın.';
      else nudge = '';

      // İndirim çubuğu: 0'dan en yüksek orana (%50) kadar tek parça. Üstte sağda en yüksek oran,
      // altında dolgunun ucunda o anki oran yazar.
      var ladderHtml = '';
      {
        var max = this.maxPct;
        // Teklif yenilenirken çubuk geri düşüp zıplamasın: son bilinen oran korunur.
        if (q || n < this.minItems) this._barPct = pct;
        else pct = this._barPct || 0;
        var shown = Math.min(pct, max);
        var fill = Math.round(shown / max * 1000) / 10;
        var from = this._fillPrev == null ? fill : this._fillPrev;
        this._fillPrev = fill;
        var cur = '';
        if (shown > 0) {
          var edge = fill >= 85 ? ' is-end' : (fill <= 15 ? ' is-start' : '');
          cur = '<span class="mys__bar-cur' + edge + '" style="left:' + fill + '%">%' + shown + ' indirim</span>';
        }
        ladderHtml = '<div class="mys__ladder">' +
          '<p class="mys__bar-max" aria-hidden="true">%' + max + dat(max) + ' kadar</p>' +
          '<div class="mys__track" role="progressbar" aria-label="Set indirimi" aria-valuemin="0" aria-valuemax="' + max + '" aria-valuenow="' + shown + '" aria-valuetext="%' + shown + ' indirim, en fazla %' + max + '">' +
          '<span class="mys__fill" style="width:' + fill + '%;--from:' + from + '%"></span></div>' +
          (cur ? '<div class="mys__bar-labels" aria-hidden="true">' + cur + '</div>' : '') + '</div>';
      }

      return '<div class="mys__st-head">' + head + '</div>' +
        '<div class="mys__set-row"><ul class="mys__tiles" role="list" aria-label="Setin">' + tiles + '</ul>' + giftSlot + '</div>' +
        giftLine +
        (nudge ? '<p class="mys__nudge" aria-live="polite">' + nudge + '</p>' : '') +
        ladderHtml;
    }

    renderPrices() {
      var t = this.totals();
      var q = this.fresh();
      var n = this.units.length;
      var pay = q ? q.pay : t.price;
      var payAll = pay + t.bags;
      var save = t.list - pay;
      // Gösterilen oran: liste fiyatına göre gerçek tasarruf (set indirimi başlamadan gösterilmez)
      var pct = q && q.pct > 0 ? Math.max(q.pct, q.realPct || 0) : 0;

      var html = this.statusHtml(t, pct);
      this.querySelectorAll('[data-status]').forEach(function (el) { el.innerHTML = html; });
      // Çanta listesindeki "hediyene X kaldı" da sunucu teklifi gelince aynı tutarla yenilenir
      this.renderBags();
      this._newId = null;

      // Özet listesi
      var sum = this.$('[data-sum-list]');
      sum.innerHTML = this.agg().map(function (a) {
        var hit = this.options[a.id];
        var o = hit.opt;
        var p = q ? this.pctFor(a.id) : 0;
        var unitPay = Math.round(o.price * (100 - p) / 100);
        return '<li><span>' + esc(hit.group.title) + (hit.group.options.length > 1 ? ' · ' + esc(o.label) : '') + (a.qty > 1 ? ' <small>×' + a.qty + '</small>' : '') + '</span>' +
          '<span>' + (o.list * a.qty > unitPay * a.qty ? '<s>' + money(o.list * a.qty) + '</s> ' : '') + money(unitPay * a.qty) + '</span></li>';
      }, this).join('');
      sum.hidden = !n;

      // Toplamlar
      this.$('[data-t-list]').textContent = money(t.list);
      var saveRow = this.$('[data-t-save-row]');
      saveRow.hidden = save <= 0;
      this.$('[data-t-save-label]').textContent = pct > 0 ? 'Set indirimi (%' + pct + ')' : 'İndirim';
      this.$('[data-t-save]').textContent = '−' + money(save);
      this.$('[data-t-bags-row]').hidden = t.bags <= 0;
      this.$('[data-t-bags]').textContent = money(t.bags);
      var giftBagsOn = this.data.bags.filter(function (b) { return t.gifts[b.variantId]; })
        .sort(function (a, b) { return (a.mode === 'set' || a.mode === 'ex' ? 0 : 1) - (b.mode === 'set' || b.mode === 'ex' ? 0 : 1); });
      this.$('[data-t-gift-row]').hidden = !giftBagsOn.length;
      if (giftBagsOn.length) this.$('[data-t-gift-label]').textContent = giftBagsOn.map(function (b) { return b.title; }).join(' + ');
      var was = this.$('[data-t-was]');
      was.hidden = save <= 0;
      was.textContent = money(t.list + t.bags);
      this.$('[data-t-pay]').textContent = money(payAll);

      // Butonlar ve mobil çubuk
      var atc = this.$('[data-atc]');
      if (!atc.dataset.label) atc.dataset.label = this.$('[data-atc-label]').textContent;
      atc.disabled = n === 0;
      this.$('[data-atc-label]').textContent = n ? atc.dataset.label + ' · ' + money(payAll) : 'Önce ürün seç';
      this.$('[data-atc-bar]').disabled = n === 0;
      this.$('[data-bar-count]').textContent = n + ' ürün' + (pct > 0 ? ' · %' + pct + ' indirim' : '');
      var bw = this.$('[data-bar-was]');
      bw.hidden = save <= 0;
      bw.textContent = money(t.list + t.bags);
      this.$('[data-bar-pay]').textContent = money(payAll);
      var nudgeEl = this.$('[data-status] .mys__nudge');
      this.$('[data-bar-nudge]').innerHTML = nudgeEl ? nudgeEl.innerHTML : '';
      if (this._updateBar) this._updateBar();
    }

    observeBar() {
      var bar = this.$('[data-bar]');
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      var visible = { section: false, summary: false };
      var update = function () { bar.hidden = !(visible.section && !visible.summary && self.units.length > 0); };
      new IntersectionObserver(function (es) { es.forEach(function (e) { visible.section = e.isIntersecting; }); update(); }).observe(this.$('.mys__layout'));
      new IntersectionObserver(function (es) { es.forEach(function (e) { visible.summary = e.isIntersecting; }); update(); }, { threshold: 0.2 }).observe(this.$('[data-atc]'));
      this._updateBar = update;
      update();
    }

    /* ---------- sepete ekle ---------- */
    addToCart() {
      if (!this.units.length || this._adding) return;
      var self = this;
      var btns = [this.$('[data-atc]'), this.$('[data-atc-bar]')];
      var err = this.$('[data-error]');
      err.hidden = true;
      this._adding = true;
      btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

      this.quote().then(function () {
        var q = self.quoteData;
        var t = self.totals();
        var gid = 'S' + Date.now().toString(36).toUpperCase().slice(-6);
        var items = self.agg().map(function (a) {
          return { id: a.id, quantity: a.qty, properties: { 'Set': 'Kendi Setin', _mys: gid } };
        });
        self.data.bags.forEach(function (b) {
          // Iconic Bag: set eşiği geçiyorsa aynı istekte eklenir (müşteri hemen ödemeye geçse de sepette olur;
          // ino-free-gift.js sonra yalnızca doğrular). İşaret, ino-free-gift.js'in eklediğiyle aynı.
          if (b.mode === 'auto') {
            if (t.gifts[b.variantId] && !self.cartHasGift) items.push({ id: b.variantId, quantity: 1, properties: { _ino_free_gift: 'true' } });
            return;
          }
          // Sepette aynı hediye zaten varsa ikinci satır eklenmez (sepet tarafını ino-free-gift.js düzenler)
          if (b.mode === 'set') {
            if (t.gifts[b.variantId] && !self.cartHasSetGift) items.push({ id: b.variantId, quantity: 1, properties: { 'Set': 'Kendi Setin · Hediye', _mys_set_gift: 'true' } });
            return;
          }
          if (b.mode === 'ex') {
            if (t.gifts[b.variantId] && !self.cartHasEx) items.push({ id: b.variantId, quantity: 1, properties: { 'Set': 'Kendi Setin · Hediye', _mys_ex_gift: 'true' } });
            return;
          }
          if (t.gifts[b.variantId]) {
            items.push({ id: b.variantId, quantity: 1, properties: { 'Set': 'Kendi Setin · Hediye' } });
          } else if (self.bagSel[b.variantId]) {
            items.push({ id: b.variantId, quantity: 1, properties: { 'Set': 'Kendi Setin' } });
          }
        });
        var n = self.units.length;
        var pct = q && q.pct > 0 ? Math.max(q.pct, q.realPct || 0) : 0;
        // "Setin sepette" penceresi için anlık görüntü (seçim sıfırlanmadan önce; ağ isteği gerektirmez)
        var setPay = q && q.units === n ? q.pay : t.price;
        var snap = {
          n: n, pct: pct, list: t.list, pay: setPay + t.bags, save: t.list - setPay,
          items: self.agg().map(function (a) {
            var hit = self.options[a.id];
            return { title: hit.group.title, label: hit.group.options.length > 1 ? hit.opt.label : '', thumb: hit.opt.thumb || hit.opt.image, hex: hit.opt.hex, qty: a.qty };
          }),
          gifts: self.data.bags.filter(function (b) { return t.gifts[b.variantId]; })
            .sort(function (a, b) { return (a.mode === 'set' || a.mode === 'ex' ? 0 : 1) - (b.mode === 'set' || b.mode === 'ex' ? 0 : 1); })
            .map(function (b) { return { title: b.title, image: b.image, price: b.price }; })
        };
        // Sepet çekmecesinin (ve sepet sayfasının) güncel HTML'i aynı istekte istenir; tema sepeti bununla yeniler
        var secs = [];
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: secs } })); } catch (e) { /* yok say */ }
        secs = secs.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
        var rendered = null;
        var body = { items: items };
        if (secs.length) body.sections = secs.join(',');
        return fetch(rootUrl() + 'cart/add.js', Object.assign({}, fetchJSONCfg(), { body: JSON.stringify(body) }))
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'add-failed');
            rendered = res.j && res.j.sections ? res.j.sections : null;
            // Sipariş "Ek bilgiler" özeti (Kendi Setini Yap) ino-free-gift.js tarafından güncel tutulur
            return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            // Sepetteki hediye durumunu hemen güncelle (bir sonraki sette aynı hediye tekrar eklenmesin)
            var its = (cart && cart.items) || [];
            var gv = Number((window.inoFreeGift || {}).variantId) || 0;
            self.cartHasGift = its.some(function (it) { return (it.properties && it.properties._ino_free_gift === 'true') || (gv && it.variant_id === gv); });
            self.cartHasSetGift = its.some(function (it) { return !!(it.properties && it.properties._mys_set_gift === 'true'); });
            self.cartHasEx = its.some(function (it) { return !!(it.properties && it.properties._mys_ex_gift === 'true'); });
            try {
              (window.dataLayer = window.dataLayer || []).push({ event: 'mys_add_to_cart', mys_items: n, mys_discount: pct, mys_value: q ? (q.pay / 100) : 0, mys_set: q && q.set ? q.set : '' });
            } catch (e) { /* yok say */ }
            // Tema sepeti (çekmece + sayfa) yeni HTML ile yenilenir; çekmece açılmaz. HTML gelmediyse tema kendisi çeker.
            var published = false;
            if (rendered && cart) {
              try {
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ino-mys-builder', cart: Object.assign({}, cart, { sections: rendered }) });
                published = true;
                // Tema güncellemeden sonra odağı kapalı çekmeceye kilitler; bizim pencere açılacağı için kilidi kaldır
                if (FoxTheme.a11y && FoxTheme.a11y.removeTrapFocus) FoxTheme.a11y.removeTrapFocus();
              } catch (e) { console.warn('[mys] cart update', e); }
            }
            document.dispatchEvent(new CustomEvent('ino-mys:added', { detail: { cart: cart, set: gid } }));
            // Genel sepet çekmecesi yerine yalnızca bu seti gösteren kompakt pencere açılır (sepet arkada güncellenir)
            if (!published) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
            self.showAdded(snap);
            self.units = [];
            self.bagSel = {};
            self.changed();
          });
      }).catch(function (e) {
        console.error('[mys] add to cart', e);
        err.hidden = false;
        err.textContent = 'Setin sepete eklenemedi' + (e && e.message && e.message !== 'add-failed' ? ': ' + e.message : '. Lütfen tekrar dene.');
        self.toast('Setin sepete eklenemedi');
      }).finally(function () {
        self._adding = false;
        btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
    }
  }

  /* ---------- "Setin sepette" penceresi ----------
   * Kendi Setini Yap'tan sepete eklenince genel sepet çekmecesi (diğer ürünler, öneriler, eklentiler)
   * yerine yalnızca bu seti gösteren küçük bir pencere açılır: ürünler kompakt iki sütunda, hediyeler,
   * set fiyatı ve "Ödemeye geç / Sepete git". Bilgiler eklemeden hemen önceki seçimden gelir; pencere
   * anında açılır, ek istek yapmaz. Mobilde alttan kayan sayfa, masaüstünde ortada pencere. */
  var ADDED_CSS =
    '.mysa{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-size:1.4rem;color:rgb(var(--color-foreground,17 17 17))}' +
    '.mysa[hidden]{display:none}' +
    '.mysa__bg{display:block !important;position:absolute;inset:0;background:rgb(0 0 0/.45);animation:mysa-fade .2s ease-out}' +
    '.mysa__p{position:relative;width:100%;max-width:52rem;max-height:92vh;max-height:92dvh;overflow-y:auto;overscroll-behavior:contain;background:rgb(var(--color-background,255 255 255));border-radius:2rem 2rem 0 0;padding:1.8rem 1.6rem calc(1.6rem + env(safe-area-inset-bottom));outline:none;animation:mysa-up .25s cubic-bezier(.3,.7,.3,1)}' +
    '@media (min-width:750px){.mysa{align-items:center}.mysa__p{border-radius:2rem;padding:2.4rem}}' +
    '@keyframes mysa-up{from{transform:translateY(3rem);opacity:0}to{transform:none;opacity:1}}@keyframes mysa-fade{from{opacity:0}}' +
    '.mysa__hd{display:flex;align-items:center;gap:1rem;padding-right:4.4rem;margin-bottom:.2rem}' +
    '.mysa__ok{flex:none;width:2.8rem;height:2.8rem;border-radius:50%;background:#008c62;color:#fff;display:grid;place-items:center}.mysa__ok svg{width:1.6rem;height:1.6rem}' +
    '.mysa__t{margin:0;font-size:1.8rem;line-height:1.25;font-weight:600;font-family:inherit;letter-spacing:0}' +
    '.mysa__sub{margin:.4rem 0 1.2rem 3.8rem;font-size:1.35rem;color:rgba(var(--color-foreground,17 17 17),.7)}.mysa__sub b{color:#008c62}' +
    '.mysa svg{width:1.6rem;height:1.6rem;flex:none}.mysa button{text-transform:none;letter-spacing:0}' +
    '.mysa__x{position:absolute;top:1rem;right:1rem;width:4.4rem;height:4.4rem;min-width:0;padding:0;border:0;border-radius:50%;background:#f6f4f2;display:grid;place-items:center;cursor:pointer;color:inherit}.mysa__x svg{width:1.8rem;height:1.8rem}' +
    '.mysa__items{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.6rem}' +
    '.mysa__it{display:flex;align-items:center;gap:.8rem;min-width:0;padding:.5rem .6rem .5rem .5rem;border-radius:1.2rem;background:#f6f4f2}' +
    '.mysa__img{position:relative;flex:none;width:4.4rem;height:4.4rem;border-radius:.9rem;background:#fff}.mysa__img img{width:100%;height:100%;object-fit:contain;border-radius:inherit;display:block}' +
    '.mysa__q{position:absolute;right:-.5rem;top:-.5rem;min-width:2rem;height:2rem;padding:0 .45rem;border-radius:1rem;background:rgb(var(--color-foreground,17 17 17));color:#fff;font-size:1.15rem;font-weight:700;display:grid;place-items:center;line-height:1}' +
    '.mysa__nm{min-width:0;font-size:1.3rem;line-height:1.25}.mysa__nm b{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-weight:600;overflow:hidden}.mysa__nm span{display:flex;align-items:center;gap:.4rem;color:rgba(var(--color-foreground,17 17 17),.7);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.mysa__dot{flex:none;width:1rem;height:1rem;border-radius:50%;box-shadow:inset 0 0 0 1px rgb(0 0 0/.15)}' +
    '.mysa__gifts{margin:1rem 0 0;padding:1rem 1.2rem;border-radius:1.2rem;background:#e5f4ee;color:#008c62}' +
    '.mysa__gh{display:flex;align-items:center;gap:.5rem;margin:0 0 .6rem;font-size:1.3rem;font-weight:700;line-height:1.2}' +
    '.mysa__gl{list-style:none;margin:0;padding:0;display:grid;gap:.6rem}' +
    '.mysa__g{display:grid;grid-template-columns:3.6rem minmax(0,1fr) auto;align-items:center;gap:1rem;padding:.4rem .8rem .4rem .4rem;border-radius:1rem;background:rgb(255 255 255/.7)}' +
    '.mysa__g img{width:3.6rem;height:3.6rem;object-fit:contain;border-radius:.8rem;background:#fff;display:block}' +
    '.mysa__gn{min-width:0;font-size:1.35rem;font-weight:600;line-height:1.25;color:rgb(var(--color-foreground,17 17 17))}' +
    '.mysa__gp{white-space:nowrap;font-size:1.3rem;text-align:right}.mysa__gp s{color:rgba(var(--color-foreground,17 17 17),.55);margin-right:.4rem}.mysa__gp b{color:#008c62;font-weight:700}' +
    '.mysa__tot{display:flex;align-items:baseline;justify-content:space-between;gap:1rem;margin:1.4rem 0 0;padding-top:1.2rem;border-top:1px solid rgba(var(--color-foreground,17 17 17),.12)}' +
    '.mysa__tot span{font-size:1.4rem}.mysa__tot div{text-align:right}.mysa__tot s{font-size:1.3rem;color:rgba(var(--color-foreground,17 17 17),.6);margin-right:.4rem}.mysa__tot strong{font-size:2rem;font-weight:700}' +
    '.mysa__save{display:block;font-size:1.3rem;color:#008c62;font-weight:600;margin-top:.2rem}' +
    '.mysa__btns{display:grid;grid-template-columns:1fr 1fr;gap:.8rem;margin-top:1.4rem}' +
    '.mysa__b{display:flex;align-items:center;justify-content:center;min-height:4.8rem;padding:0 1.2rem;border-radius:2.4rem;font-size:1.5rem;font-weight:600;text-decoration:none !important;border:1.5px solid rgb(var(--color-foreground,17 17 17));text-align:center;line-height:1.2}' +
    '.mysa__b--pri{background:rgb(var(--color-foreground,17 17 17));color:rgb(var(--color-background,255 255 255)) !important}.mysa__b--sec{background:transparent;color:inherit !important}' +
    '.mysa__more{display:block;width:100%;margin-top:.6rem;min-height:4.4rem;padding:0;border:0;background:none;font-size:1.35rem;text-decoration:underline;text-underline-offset:.25rem;color:rgba(var(--color-foreground,17 17 17),.75);cursor:pointer}' +
    '.mysa button:focus-visible,.mysa a:focus-visible{outline:2px solid rgb(var(--color-foreground,17 17 17));outline-offset:2px}' +
    '@media (max-width:359px){.mysa__items{grid-template-columns:1fr}}' +
    '@media (prefers-reduced-motion:reduce){.mysa__p,.mysa__bg{animation:none}}';

  MysBuilder.prototype.showAdded = function (snap) {
    var self = this;
    if (!document.getElementById('mysa-css')) {
      var st = document.createElement('style');
      st.id = 'mysa-css';
      st.textContent = ADDED_CSS;
      document.head.appendChild(st);
    }
    var old = document.querySelector('.mysa');
    if (old) old.remove();
    var root = rootUrl();
    var items = snap.items.map(function (it) {
      return '<li class="mysa__it"><span class="mysa__img">' + (it.thumb ? '<img src="' + esc(it.thumb) + '" alt="" width="88" height="88">' : '') +
        (it.qty > 1 ? '<i class="mysa__q">×' + it.qty + '</i>' : '') + '</span>' +
        '<span class="mysa__nm"><b>' + esc(it.title) + '</b>' + (it.label ? '<span>' + (it.hex ? '<i class="mysa__dot" style="background:' + esc(it.hex) + '"></i>' : '') + esc(it.label) + '</span>' : '') + '</span></li>';
    }).join('');
    // Hediyeler alt alta: görsel · ad · (eski fiyat) Hediye
    var gifts = snap.gifts.length ? '<div class="mysa__gifts"><p class="mysa__gh">' + ICON_GIFT + ' ' + (snap.gifts.length > 1 ? 'Hediyelerin' : 'Hediyen') + '</p><ul class="mysa__gl" role="list">' + snap.gifts.map(function (g) {
      return '<li class="mysa__g"><span>' + (g.image ? '<img src="' + esc(g.image) + '" alt="" width="72" height="72">' : '') + '</span>' +
        '<span class="mysa__gn">' + esc(g.title) + '</span>' +
        '<span class="mysa__gp">' + (g.price > 0 ? '<s>' + money(g.price) + '</s>' : '') + '<b>Hediye</b></span></li>';
    }).join('') + '</ul></div>' : '';
    var el = document.createElement('div');
    el.className = 'mysa';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'mysa-t');
    el.innerHTML = '<div class="mysa__bg" data-mysa-close></div>' +
      '<div class="mysa__p" tabindex="-1">' +
        '<button type="button" class="mysa__x" data-mysa-close aria-label="Kapat">' + ICON_X + '</button>' +
        '<div class="mysa__hd"><span class="mysa__ok">' + ICON_CHECK + '</span><h2 class="mysa__t" id="mysa-t">Setin sepete eklendi</h2></div>' +
        '<p class="mysa__sub">' + snap.n + ' ürün' + (snap.pct > 0 ? ' · <b>%' + snap.pct + ' set indirimi</b>' : '') + '</p>' +
        '<ul class="mysa__items" role="list">' + items + '</ul>' + gifts +
        '<div class="mysa__tot"><span>Set tutarı</span><div>' + (snap.save > 0 ? '<s>' + money(snap.list) + '</s>' : '') + '<strong>' + money(snap.pay) + '</strong>' +
          (snap.save > 0 ? '<span class="mysa__save">' + money(snap.save) + ' kazancın</span>' : '') + '</div></div>' +
        '<div class="mysa__btns"><a class="mysa__b mysa__b--sec" href="' + root + 'cart">Sepete git</a><a class="mysa__b mysa__b--pri" href="' + root + 'checkout">Ödemeye geç</a></div>' +
        '<button type="button" class="mysa__more" data-mysa-close data-mysa-more>Yeni bir set daha oluştur</button>' +
      '</div>';
    document.body.appendChild(el);
    document.documentElement.classList.add('mys-lock');
    var back = document.activeElement;
    var panel = el.querySelector('.mysa__p');
    var close = function (more) {
      el.remove();
      document.documentElement.classList.remove('mys-lock');
      document.removeEventListener('keydown', onKey);
      if (more && self.isConnected) {
        var top = self.querySelector('.mys__head') || self;
        top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (back && back.focus) back.focus({ preventScroll: true });
    };
    var onKey = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      // Odak pencerenin içinde kalsın
      var f = el.querySelectorAll('a[href], button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener('click', function (e) {
      var c = e.target.closest('[data-mysa-close]');
      if (c) close(c.hasAttribute('data-mysa-more'));
    });
    document.addEventListener('keydown', onKey);
    setTimeout(function () { panel.focus(); }, 30);
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'mys_added_panel', mys_items: snap.n }); } catch (e) { /* yok say */ }
  };

  customElements.define('mys-builder', MysBuilder);
})();
